import messages from './cmsCreate.json' with { type: 'json' };

export const cmsCreateFi: Readonly<typeof messages> = messages;
